function hasRout(num,navigate) {
    let rout;
    if (num == 403) {
        rout =navigate("/page404")
    }
    return rout;
}

export { hasRout }